import { hydrate } from "preact";
import App, { AppProps } from "./App.tsx";
import "../app/init.ts";

const initialData = globalThis.__INITIAL_DATA__ as AppProps;

hydrate(<App data={initialData} />, document.getElementById("root")!);